import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import { LeadComponent } from "./dashboard.component";
import { HighlightSearch } from "src/app/shared/pipes/highlight.pipe";
import { LeadRoutingModule } from "./dashboard-routing.module";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NzCardModule } from "ng-zorro-antd/card";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzInputModule } from "ng-zorro-antd/input";
// echarts
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NzStatisticModule } from "ng-zorro-antd/statistic";
import { NzGridModule } from "ng-zorro-antd/grid";
@NgModule({
  imports: [
    LeadRoutingModule,
    NzGridModule,
    BrowserModule,
    FormsModule,
    NzCardModule,
    NzStatisticModule,
    NzInputModule,
    NzCheckboxModule,
    NgxChartsModule,
  ],
  declarations: [LeadComponent, HighlightSearch],
  exports: [LeadComponent, HighlightSearch],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DashboardModule {}
